import React, {useState} from "react";
import ProfileContainer from "../components/ProfileContainer";
import ProfileJobRow from "../components/ProfileJobRow";

const MAX_LENGTH = 3;

const TalentProfileWorkHistory = ({items}) => {

    const [isWorkHistoryOpen, setIsWorkHistoryOpen] = useState(false);


    return (
        <div id="work-history" className="pt-2 pb-8">
            <ProfileContainer>
                <div>
                    <h4 className="textbold text-lg">Work History  {!!items?.length && `(${items.length})`}</h4>

                    {!items?.length && (
                        <div className="py-8 text-center">
                            <p className="text-base">No Work History Available</p>
                        </div>
                    )}

                    <div className="flex gap-6 flex-col divide-y">

                        {items?.slice(0, isWorkHistoryOpen ? items.length : MAX_LENGTH).map(job => (
                            <ProfileJobRow key={job.id} job={job} />
                        ))}
                    </div>

                    {items?.length > MAX_LENGTH && (
                        <div className="pt-6 flex justify-end">
                            <button
                                type="button"
                                className="btn-outline flex items-center gap-2 p-1.5 px-2.5 transition hover:bg-wrippleOffWhite"
                                onClick={() => setIsWorkHistoryOpen(!isWorkHistoryOpen)}
                            >
                                <p>{items.length - MAX_LENGTH} {isWorkHistoryOpen ? 'less' : 'more'}</p>
                                <div className="bg-wrippleOffWhite h-6 w-6 shrink-0 flex items-center justify-center">
                                    <i className={TB.mapClass("fa fa-chevron-down transition text-base", {'rotate-180': isWorkHistoryOpen})}/>
                                </div>
                            </button>
                        </div>
                    )}

                </div>
            </ProfileContainer>
        </div>

    )
}

export default TalentProfileWorkHistory;


// const TalentProfileWorkHistory2 = () => {
//     const {talent} = useTalent();

//     return (
//         <ProfileContainer>
//             <div id="work-history">
//                 <h4 className="text-bold font-xl pb-6">Work History</h4>

//                 <div className="flex flex-col gap-6 pb-6">
//                     {talent.jobs?.map(job => {
//                         return (
//                             <div key={job.id} className="flex justify-between">
//                                 <div>
//                                     <p className="font-lg font-bold">{job.role}</p>
//                                     <p>{job.employer}</p>
//                                     <p className="text-wrippleBlueGray">{TB.moment(job.started_at).format('ll')} - {job.ended_at ? TB.moment(job.ended_at).format('ll') : 'Now'}</p>
//                                 </div>

//                                 <div>
//                                     <button type="button" className="btn btn-outline-dark">
//                                         {/* View Work Responsibilities */}
//                                         modal of responsibilities for this job?
//                                     </button>
//                                 </div>
//                             </div>
//                         )
//                     })}
//                 </div>
//             </div>
//         </ProfileContainer>
//     )
// }

// export default TalentProfileWorkHistory;